export class RoleEnum {
    // ADMINISTRATOR:
    // Has access to all pages and can execute all API calls.
    static ADMINISTRATOR = 'Administrator'

    // IMPORTER accounts.
    // Does not have access to any UI pages. Account that is only used for importing JIRA csv.
    static IMPORTER = 'Importer'

    // Timesheet user:
    // Has access to most pages and API calls, but not to account management.
    static TIMESHEET_USER = 'TimesheetUser'

    // Restricted user:
    // Has access to most pages and API calls, but not to account management.
    // Can only view data, but not create, modify, approve, etc.
    static RESTRICTED_USER = 'RestrictedUser'

    static ALL = [RoleEnum.ADMINISTRATOR, RoleEnum.TIMESHEET_USER, RoleEnum.RESTRICTED_USER]
    static ALL_BUT_RESTRICTED = [RoleEnum.ADMINISTRATOR, RoleEnum.TIMESHEET_USER]
}
